import { React, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { motion } from "motion/react"
import Swal from 'sweetalert2';
import useInitUI from '../scripts/main'
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

export default function Home() {
    const navigate = useNavigate();
    const [givenName, setGivenName] = useState('');
    const [surName, setSurName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [comment, setComment] = useState('');
    const [showModal, setShowModal] = useState(false);


    const handleContact = async (e) => {
        e.preventDefault();

        try {
            const token = await window.grecaptcha.execute('6LeGUzIrAAAAAPGKtDUVNK-vajMwHnN6WZqVy6wf', { action: 'contact' });
            const response = await fetch('https://api.novaetus.net/contact', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer SIC7LVDICRqkXB2GP3G50hqSwgRmBcuF9FwlZEFwJCerROi2ZJ2CMRXo73mesvHV',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ givenName, surName, email, phone, comment, recaptchaToken: token }),
            });

            if (response.ok) {
                //const data = await response.json();
                console.log('You message has been sent successfully.');
                Swal.fire({
                    icon: 'success',
                    text: 'You message has been sent successfully.',
                });
                navigate('/');
            } else {
                const error = await response.json();
                Swal.fire({
                    icon: 'error',
                    title: 'Your message has not been sent, please try again.',
                    text: error.message,
                });
                console.log(error.message);
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Something went wrong!',
                text: error,
            });
            console.error('Error during /contact:', error);
        }
    };

    //path-drawing
    const draw = {
        hidden: { pathLength: 0, opacity: 0 },
        visible: (i) => {
            const delay = i * 0.5;
            return {
                pathLength: 1,
                opacity: 1,
                transition: {
                    pathLength: { delay, type: "spring", duration: 1.5, bounce: 0, repeat: Infinity, },
                    opacity: { delay, duration: 0.01, },
                },
            };
        },
    };
    const shape = {
        strokeWidth: 10,
        strokeLinecap: "round",
        fill: "transparent",
    };

    useInitUI();
    return (
        <div>
            <Helmet>
                <title>Novaetus</title>
            </Helmet>

            <div>
                <div id="preloader">
                    <div id="preloader-status">
                        <div className="preloader-ripple">
                            <div />
                            <div />
                        </div>
                    </div>
                </div>
                <header className="header-area style-1">
                    <div className="te-header-menu-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-3 col-lg-3 col-md-6 col-6 d-flex align-items-center">
                                    <div className="te-logo">
                                        <Link to="/" className="te-standard-logo">
                                            <img src="assets/images/logo.png" width={70} alt="Novaetus" />
                                        </Link>
                                        <Link to="/" className="te-sticky-logo">
                                            <img src="assets/images/logo.png" width={70} alt="Novaetus" />
                                        </Link>
                                        <Link to="/" className="te-retina-logo">
                                            <img src="assets/images/logo.png" width={70} alt="Novaetus" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-xl-9 col-lg-9 col-md-6 col-6 d-flex align-items-center justify-content-end">
                                    <div className="te-menu d-inline-block">
                                        <nav id="main-menu" className="te-main-menu">
                                            <ul>
                                                <li><Link to="/">Home</Link></li>
                                                <li><Link to="/#about">About</Link></li>
                                                <li><Link onClick={() => setShowModal(true)}>Contact</Link></li>
                                                <li><Link to="/#products">Products</Link></li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <div className="te-header-btn">
                                        <Link className="te-quote-btn" onClick={() => setShowModal(true)}>Get in touch</Link>
                                    </div>
                                    <div className="te-mobile-menu-bar d-lg-none text-end">
                                        <Link to="/#" className="te-mobile-menu-toggle-btn"><i className="fa fa-bars-staggered" /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="te-menu-sidebar-area">
                    <div className="te-menu-sidebar-wrapper">
                        <div className="te-menu-sidebar-close">
                            <button className="te-menu-sidebar-close-btn" id="menu_sidebar_close_btn">
                                <i className="fa fa-times" />
                            </button>
                        </div>
                        <div className="te-menu-sidebar-content">
                            <div className="te-menu-sidebar-logo">
                                <Link to="/">
                                    <img src="assets/images/logo.png" width={70} alt="Novaetus" />
                                </Link>
                            </div>
                            <div className="te-mobile-nav-menu" />
                            <div className="te-menu-sidebar-content">
                                <div className="te-menu-sidebar-single-widget">
                                    <h5 className="te-menu-sidebar-title">Contact Info</h5>
                                    <div className="te-header-contact-info">
                                        <span><i className="fa-solid fa-location-dot" />Kampala, Uganda</span>
                                        <span><Link to="/mailto:contact@novaetus.net"><i className="fa-solid fa-envelope" />contact@novaetus.net</Link> </span>
                                    </div>
                                    <div className="te-social-profile">
                                        <Link to="https://x.com/nvaetus" target="_blank"><i className="fa-brands fa-x-twitter" /></Link>
                                        <Link to="https://www.linkedin.com/company/novaetus" target="_blank"><i className="fa-brands fa-linkedin-in" /></Link>
                                        <Link to="https://www.instagram.com/nvaetus" target="_blank"><i className="fa-brands fa-instagram" /></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="te-body-overlay" />
                <div className="banner-area style-1">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="te-banner-content">
                                    <h1 className="gradient-title" style={{ backgroundImage: 'url("assets/images/title-bg.png")' }}>
                                        <span>Beyond <br /> Innovation</span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                        <div className="row gy-5 justify-content-center banner-content-row">
                            <div className="col-lg-5 align-self-center">
                                <div className="banner-info-card style-1 text-center">
                                    <div className="content-wrapper">
                                        <p>
                                            At Novaetus, we leverage blockchain and blockchain-related technologies to
                                            develop purpose-driven solutions and services. We build tools that help you
                                            create, grow, and transform your ideas into reality.
                                        </p>
                                    </div>
                                    <div className="d-flex justify-content-center mt-5">
                                        <Link to="https://hivebn.com" target="_blank">
                                            <div className="prod-icon mx-3">
                                                <img src="assets/images/hivebn.png" width={50} alt="icon" />
                                            </div>
                                        </Link>
                                        <div className="prod-icon mx-3">
                                            <img src="assets/images/musebn.png" width={50} alt="icon" />
                                        </div>
                                        <div className="prod-icon mx-3">
                                            <img src="assets/images/prismbn.png" width={50} alt="icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="blur-shape" />
                        </div>
                    </div>
                </div>
                <section id="about">
                    <div className="about-feature-area">
                        <div className="circle-drop-shadow" />
                        <div className="container">
                            <div className="row gy-4 align-items-center justify-content-between">
                                <div class="col-lg-4 wow animate__animated animate__slideInLeft animate__slow">
                                    <div className="about-us-card">
                                        <div className="te-section-title">
                                            <div className="te-section-content">
                                                <div className="short-title-wrapper">
                                                    <span className="short-title">ABOUT US</span>
                                                </div>
                                                <p>Since our founding in 2022, we have been committed to making complex technology simple and useful for everyone from small businesses to global enterprises.</p>
                                            </div>
                                        </div>
                                        <div className="te-list-item-wrapper">
                                            <div className="row justify-content-between">
                                                <div className="col-lg-12 mb-3">
                                                    <span className="small-title">MISSION</span>
                                                    <p>To craft solutions that inspire our users to explore and innovate.</p>
                                                </div>
                                                <div className="col-lg-12 mb-3">
                                                    <span className="small-title">VISION</span>
                                                    <p>To be the pinnacle of innovation fuelling tomorrow’s ideas.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 wow animate__animated animate__zoomIn animate__slow">
                                    <div className="svg-container d-flex justify-content-center">
                                        <motion.svg width="600" height="600" viewBox="0 0 600 600" initial="hidden" animate="visible" preserveAspectRatio="xMidYMid meet" className="svg-fluid" >
                                            <motion.circle className="circle-path" cx="100" cy="100" r="80" stroke="#ffffff" variants={draw} custom={1} style={shape} />
                                            <motion.line x1="220" y1="30" x2="360" y2="170" stroke="#818589" variants={draw} custom={2} style={shape} />
                                            <motion.line x1="220" y1="170" x2="360" y2="30" stroke="#818589" variants={draw} custom={2.5} style={shape} />
                                            <motion.rect width="140" height="140" x="410" y="30" rx="20" stroke="#ffffff" variants={draw} custom={3} style={shape} />
                                            <motion.circle cx="100" cy="300" r="80" stroke="#818589" variants={draw} custom={2} style={shape} />
                                            <motion.line x1="220" y1="230" x2="360" y2="370" stroke="#ffffff" custom={3} variants={draw} style={shape} />
                                            <motion.line x1="220" y1="370" x2="360" y2="230" stroke="#ffffff" custom={3.5} variants={draw} style={shape} />
                                            <motion.rect width="140" height="140" x="410" y="230" rx="20" stroke="#818589" custom={4} variants={draw} style={shape} />
                                            <motion.circle cx="100" cy="500" r="80" stroke="#ffffff" variants={draw} custom={3} style={shape} />
                                            <motion.line x1="220" y1="430" x2="360" y2="570" stroke="#818589" variants={draw} custom={4} style={shape} />
                                            <motion.line x1="220" y1="570" x2="360" y2="430" stroke="#818589" variants={draw} custom={4.5} style={shape} />
                                            <motion.rect width="140" height="140" x="410" y="430" rx="20" stroke="#ffffff" variants={draw} custom={5} style={shape} />
                                        </motion.svg>
                                    </div>
                                </div>
                                <div className="col-lg-5 wow animate__animated animate__slideInRight animate__slower">
                                    <div className="about-us-card">
                                        <div className="te-section-title">
                                            <div className="te-section-content">
                                                <div className="short-title-wrapper">
                                                    <span className="short-title">ETHOS</span>
                                                </div>
                                                <p>We believe true innovation is pointless unless it serves every creator, across all socioeconomic strata. Our hallmark is our frictionless, transparent platforms that democratise blockchain’s potential without compromise.</p>
                                                <div className="short-title-wrapper">
                                                    <span className="short-title">TENETS</span>
                                                </div>
                                                <div className="te-list-item-wrapper">
                                                    <div className="te-list-item">
                                                        <span className="icon">
                                                            <i className="fa-solid fa-angles-right" />
                                                        </span>
                                                        <span className="text">Effortless Experience: Intuitive designs that fit right into your workflow.</span>
                                                    </div>
                                                    <div className="te-list-item">
                                                        <span className="icon">
                                                            <i className="fa-solid fa-angles-right" />
                                                        </span>
                                                        <span className="text">Total Transparency: Clear, honest communication in every step.</span>
                                                    </div>
                                                    <div className="te-list-item">
                                                        <span className="icon">
                                                            <i className="fa-solid fa-angles-right" />
                                                        </span>
                                                        <span className="text">Inclusive Access: Technology that anyone can tap into.</span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="products" className="mb-100">
                    <div className="circle-drop-shadow" />
                    <div className="work-prgress-area style-1">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 wow animate__animated animate__slideInDown animate__slow">
                                    <div className="te-section-title justify-content-center text-center">
                                        <div className="te-section-content">
                                            <div>
                                                <span className="short-title">PORTFOLIO</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row gy-5">
                                <div className="col-lg-4 col-md-6 te-process-two-step-wrapper wow animate__animated animate__fadeInTopLeft animate__slow">
                                    <div className="te-process-step style-2">
                                        <div className="te-content-wrapper">
                                            <div className="te-title-wrapper">
                                                <div className="icon-wrapper">
                                                    <div className="icon">
                                                        <img src="assets/images/hivebn.png" className="prod-img" alt="Hive by Novaetus" />
                                                    </div>
                                                </div>
                                                <h3 className="title">HIVE <span className="small-title">BY NOVAETUS</span></h3>
                                                <div className="shape-image">
                                                    <img className="shape-1" src="assets/images/shape.png" alt="shape" />
                                                    <img className="shape-2" src="assets/images/shape-two.png" alt="shape" />
                                                </div>
                                            </div>
                                            <div className="content">
                                                <p className="desc">A secure, straightforward, and reliable platform connecting freelancers and
                                                    clients.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 te-process-two-step-wrapper wow animate__animated animate__fadeInUp animate__slow">
                                    <div className="te-process-step style-2">
                                        <div className="te-content-wrapper">
                                            <div className="te-title-wrapper">
                                                <div className="icon-wrapper">
                                                    <div className="icon">
                                                        <img src="assets/images/musebn.png" className="prod-img" alt="MUSE by Novaetus" />
                                                    </div>
                                                </div>
                                                <h3 className="title">MUSE <span className="small-title">BY NOVAETUS</span></h3>
                                                <div className="shape-image">
                                                    <img className="shape-1" src="assets/images/shape.png" alt="shape" />
                                                    <img className="shape-2" src="assets/images/shape-two.png" alt="shape" />
                                                </div>
                                            </div>
                                            <div className="content">
                                                <p className="desc">Merging Unique Social Elements is a social-learning hub where creators share
                                                    content, connect, and learn, all in one place.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 te-process-two-step-wrapper wow animate__animated animate__fadeInTopRight animate__slow">
                                    <div className="te-process-step style-2">
                                        <div className="te-content-wrapper">
                                            <div className="te-title-wrapper">
                                                <div className="icon-wrapper">
                                                    <div className="icon">
                                                        <img src="assets/images/prismbn.png" className="prod-img" alt="Prism by Novaetus" />
                                                    </div>
                                                </div>
                                                <h3 className="title">PRISM <span className="small-title">BY NOVAETUS</span></h3>
                                                <div className="shape-image">
                                                    <img className="shape-1" src="assets/images/shape.png" alt="shape" />
                                                    <img className="shape-2" src="assets/images/shape-two.png" alt="shape" />
                                                </div>
                                            </div>
                                            <div className="content">
                                                <p className="desc">An all-in-one finance platform that handles payments, banking, and other
                                                    digital financial services seamlessly.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="team">
                    <div className="testimonial-slider-area style-1 mb-200 wow animate__animated animate__flipInX animate__slow">
                        <div className="testimonial-slider-area style-1">
                            <div className="testimonial-slider-border">
                                <div className="container">
                                    <div className="row">
                                        <div class="col-12 mt-5 wow animate__animated animate__slideInDown animate__slow">
                                            <div className="te-section-title left-align-title">
                                                <div className="te-section-content">
                                                    <div>
                                                        <span className="short-title only-divider">LEADERSHIP</span>
                                                    </div>
                                                </div>
                                                <div className="te-section-desc">
                                                    <div className="te-slider-btn-wrapper">
                                                        <Link to="#" className="te-slider-nav te-slider-prev" id="testimonial_slider_prev">
                                                            <i className="fa-solid fa-arrow-left" />
                                                        </Link>
                                                        <Link to="#" className="te-slider-nav te-slider-next" id="testimonial_slider_next">
                                                            <i className="fa-solid fa-arrow-right" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="te-testimonial-slider-wrapper" id="testimonial_one">
                                                <div className="slick-single-item">
                                                    <div className="te-testimonial-card style-1">
                                                        <div className="te-content-wrapper">
                                                            <div className="te-user-meta">
                                                                <div className="te-user-info">
                                                                    <div className="info">
                                                                        <h3 className="name">Irwin Mubiru</h3>
                                                                        <span className="designation">President</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="slick-single-item">
                                                    <div className="te-testimonial-card style-1">
                                                        <div className="te-content-wrapper">
                                                            <div className="te-user-meta">
                                                                <div className="te-user-info">
                                                                    <div className="info">
                                                                        <h3 className="name">Makuei Makur Akec</h3>
                                                                        <span className="designation">Deputy President</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="slick-single-item">
                                                    <div className="te-testimonial-card style-1">
                                                        <div className="te-content-wrapper">
                                                            <div className="te-user-meta">
                                                                <div className="te-user-info">
                                                                    <div className="info">
                                                                        <h3 className="name">Joan Ankunda</h3>
                                                                        <span className="designation">General Counsel</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="slick-single-item">
                                                    <div className="te-testimonial-card style-1">
                                                        <div className="te-content-wrapper">
                                                            <div className="te-user-meta">
                                                                <div className="te-user-info">
                                                                    <div className="info">
                                                                        <h3 className="name">William Kyangabo</h3>
                                                                        <span className="designation">Director Corporate Finance</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="slick-single-item">
                                                    <div className="te-testimonial-card style-1">
                                                        <div className="te-content-wrapper">
                                                            <div className="te-user-meta">
                                                                <div className="te-user-info">
                                                                    <div className="info">
                                                                        <h3 className="name">Amon Amanya Byona</h3>
                                                                        <span className="designation">Director Product Development</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="slick-single-item">
                                                    <div className="te-testimonial-card style-1">
                                                        <div className="te-content-wrapper">
                                                            <div className="te-user-meta">
                                                                <div className="te-user-info">
                                                                    <div className="info">
                                                                        <h3 className="name">Joses Ainembabazi</h3>
                                                                        <span className="designation">Director Cybersecurity</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="contact" className="mb-200">
                    {showModal && (
                        <div className="modal-overlay">
                            <div className="modal-content  wow animate__animated animate__bounceIn animate__slower">
                                <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
                                <div className="">
                                    <div className="">
                                        <div className="te-comment-respond mt-0">
                                            <form onSubmit={handleContact} className="te-comment-form" method="post">
                                                <div className="row gx-4">
                                                    <div className="col-xl-6">
                                                        <div className="te-contacts-name">
                                                            <input name="name" type="text" placeholder="Given Name" value={givenName} onChange={(e) => setGivenName(e.target.value)} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <div className="te-contacts-name">
                                                            <input name="name" type="text" placeholder="Surname" value={surName} onChange={(e) => setSurName(e.target.value)} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <div className="te-contacts-email">
                                                            <input name="email" type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <div className="te-contacts-name">
                                                            <IntlTelInput
                                                                preferredCountries={['ug']}
                                                                formatOnInit={false}
                                                                fieldId="phone"
                                                                inputClassName="form-control"
                                                                onPhoneNumberChange={(status, value) => {
                                                                    setPhone(value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-12">
                                                        <div className="te-contacts-message">
                                                            <textarea name="comment" cols={20} rows={3} placeholder="Write your message here" value={comment} onChange={(e) => setComment(e.target.value)} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-12 text-center">
                                                        <button className="te-theme-btn blue-btn rounded-1" type="submit">
                                                            Send Message
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </section>

                <footer className="footer style-2">
                    <div className="te-footer-sec">
                        <div className="container">
                            <div className="row gy-5">
                                <div className="col-lg-4 te-footer-widget-wrapper">
                                    <div className="te-footer-widget">
                                        <div className="te-footer-widget-info">
                                            <div className="row justify-content-between">
                                                <div className="col-lg-12 mb-3 text-center">
                                                    <Link to="/"><img src="assets/images/logo.png" width={200} alt="Novaetus" /></Link>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 offset-lg-1 te-footer-widget-wrapper">
                                    <div className="te-footer-widget">
                                        <div className="te-footer-widget-newsletter">
                                            <div className="circle-drop-shadow" />
                                            <p className="col-lg-12">Novaetus leverages blockchain and blockchain-related technologies to develop purpose-driven solutions and services that help you transform your ideas into reality.</p>
                                            <div className="te-social-profile">
                                                <Link to="https://x.com/nvaetus" target="_blank"><i className="fab fa-x-twitter" /></Link>
                                                <Link to="https://www.linkedin.com/company/novaetus" target="_blank"><i className="fab fa-linkedin-in" /></Link>
                                                <Link to="https://www.instagram.com/nvaetus" target="_blank"><i className="fab fa-instagram" /></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="footer-bottom-border" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-bottom-area">
                        <div className="container">
                            <div className="te-footer-bottom-wrapper">
                                <div className="te-copyright-text text-center">
                                    <p>Novaetus Technologies &copy; {new Date().getFullYear()}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <div className="progress-wrap">
                    <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                        <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                    </svg>
                </div>
            </div>
            <useInitUI />
        </div>
    );
}